import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Language } from '../types/language.types';
import { environment } from 'src/environments/environment';
import { TranslateService } from '@ngx-translate/core';
import { map, startWith } from 'rxjs/operators';
import { defer, merge } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LanguageService {
  /** Emits `true` when the active app language is Czech. */
  readonly isCzech$ = merge(
    defer(() => [this.translateService.currentLang]),
    this.translateService.onLangChange.pipe(map(e => e.lang))
  ).pipe(map(lang => lang === 'cz'));
  constructor(
    private http: HttpClient,
    private translateService: TranslateService
  ) {}

  /**
   * Returns languages
   * @returns languages
   */
  public getLanguages() {
    return this.http.get<Language[]>(environment.apiUrl + '/languages/');
  }

  public searchLanguages(searchString: string) {
    return this.http.get<Language[]>(
      environment.apiUrl + '/languages/search/' + searchString + '/' + this.translateService.getCurrentLang()
    );
  }
}
